module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'hcvklqud',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
